import { render, staticRenderFns } from "./EnquetesNew.vue?vue&type=template&id=9e408052&"
import script from "./EnquetesNew.vue?vue&type=script&lang=js&"
export * from "./EnquetesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports